
import axios from 'axios';
import Cookies from "js-cookie";
import ELocalStorageKeys from 'types/LocalStorageKey';
import { notifySessionExpired, refreshAccessToken } from 'utils/authSession';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/',
    // timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to always get the latest token
axiosInstance.interceptors.request.use((config) => {
    const token = Cookies.get(ELocalStorageKeys.AccessToken);
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        if (config.headers && config.headers.Authorization) {
            delete config.headers.Authorization;
        }
    }
    return config;
});

// Expired/invalid token: get a new access token with the refresh token and
// retry the request once. If that fails, clear the session so ProtectedRoutes
// redirects to login. Only for requests that carried a token, so
// unauthenticated calls (e.g. reset password with a URL token) are not affected.
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error?.config;
        const sentAuthHeader = Boolean(originalRequest?.headers?.Authorization);

        if (error?.response?.status !== 401 || !sentAuthHeader) {
            return Promise.reject(error);
        }

        if (!originalRequest._retriedAfterRefresh) {
            originalRequest._retriedAfterRefresh = true;

            const newAccessToken = await refreshAccessToken();

            if (newAccessToken) {
                // The request interceptor sets the new token from the cookie.
                return axiosInstance(originalRequest);
            }
        }

        notifySessionExpired();
        return Promise.reject(error);
    }
);

export default axiosInstance;